import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StatusInProgress = function StatusInProgress(props) {
  return /*#__PURE__*/ _jsxs(
    "svg",
    _extends(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
      },
      props,
      {
        children: [
          /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.95215 3.23438C13.6938 3.23438 16.7273 6.26787 16.7273 10.0095C16.7273 13.7511 13.6938 16.7846 9.95215 16.7846V3.23438Z",
            fill: "#F79009",
          }),
          /*#__PURE__*/ _jsx("path", {
            d: "M10 1.91388C14.4689 1.91388 18.0861 5.5311 18.0861 10C18.0861 14.4689 14.4689 18.0861 10 18.0861C5.5311 18.0861 1.91388 14.4689 1.91388 10C1.91388 5.5311 5.5311 1.91388 10 1.91388ZM10 0C4.48804 0 0 4.48804 0 10C0 15.512 4.48804 20 10 20C15.512 20 20 15.512 20 10C20 4.48804 15.512 0 10 0Z",
            fill: "#FDB022",
          }),
        ],
      }
    )
  );
};
export default StatusInProgress;
